/**
 * Flow D's money routes: D4, D5, D6 and D7.
 *
 * D7's path is `/receipt/:ref` rather than a child of `/checkout` — docs/11's map — so
 * it is declared here with the rest of the money flow it belongs to.
 */
import type { RouteObject } from 'react-router-dom';
import { withSurfaceStates } from '../../states/boundary.js';
import { D4Checkout } from './D4Checkout.js';
import { D5Payment } from './D5Payment.js';
import { D6Done } from './D6Done.js';
import { D7Receipt } from './D7Receipt.js';

/**
 * WP-K · state branches. `withSurfaceStates` wraps every element of this group in the
 * boundary for its matrix column (transaction · লেনদেন); see
 * `apps/web/src/states/boundary.tsx`. It changes nothing about the healthy render — no
 * state resolves unless an API error body says so, so the screens below are untouched
 * and their fidelity gate still measures what it measured.
 */
export const checkoutRoutes: RouteObject[] = withSurfaceStates('transaction', [
  { path: '/checkout', element: <D4Checkout /> },
  { path: '/checkout/payment', element: <D5Payment /> },
  { path: '/checkout/done', element: <D6Done /> },
  { path: '/receipt/:ref', element: <D7Receipt /> },
]);
